import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { _mockDocumentTypes } from './getDocumentTypes';
import { StackFilterDetails, StackFilterDocument } from './types';
import { _mockStackFilters } from './getStackFilters';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getStackFilter: QueryFunction<
  StackFilterDetails,
  ['/stack-filter', string]
> = async ({ queryKey }) => {
  // Guard clause to prevent execution if no valid ID is provided
  if (!queryKey[1] || queryKey[1].trim() === '') {
    throw new Error('Stack filter ID is required');
  }

  if (isMockServices()) return await mock(_mockStackFilter(queryKey[1]));
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    filter: {
      configuration: {
        orderedDocumentTypeIds: StackFilterDocument[];
      };
      name: string;
      id: string;
      isOrganization: boolean;
    };
  }>(`/search-filters/${queryKey[1]}`, {
    method: 'GET',
  });
  if (response.data)
    return {
      id: response.data.filter.id,
      name: response.data.filter.name,
      isOrganization: false,
      documentTypes: response.data.filter.configuration.orderedDocumentTypeIds,
    };
  throw new Error('Failed to fetch stack filter');
};

export default getStackFilter;

const _mockStackFilter = (id: string): StackFilterDetails => ({
  id,
  name: _mockStackFilters[((parseInt(id) ?? 1) - 1) % _mockStackFilters.length]
    .name,
  isOrganization: true,
  documentTypes: [
    {
      documentTypeId: _mockDocumentTypes[0].id,
      required: false,
      filesPerBorrower: 2,
      validityRule: 'Last month',
    },
    {
      documentTypeId: _mockDocumentTypes[1].id,
      required: false,
      filesPerBorrower: 2,
      validityRule: 'Last month',
    },
    {
      documentTypeId: _mockDocumentTypes[2].id,
      required: false,
      filesPerBorrower: 2,
      validityRule: 'Last month',
    },
  ],
});
